import axios from 'axios'
import {
  getPackageListPathname,
  getPackageWithSticker,
  postPackagePathname,
  putPackagePathname,
  putPackageResetPathname,
  putPackageStatusEditing,
  submitPackagePathname,
} from './pathname'

export const getPackageWithStickerAPI = async ({
  packageId,
  sessionToken,
}: any) => {
  const { data } = await axios.get(
    getPackageWithSticker(packageId) + '?include=inspection',
    {
      headers: {
        session: sessionToken,
      },
    },
  )
  return data
}
export const postPackageAPI = async ({
  formData,
  sessionToken,
}: PostPackageAPI) => {
  const { data } = await axios.post(postPackagePathname, formData, {
    headers: {
      session: sessionToken,
    },
  })
  return data
}

export const getMyPackageList = async ({
  userOid,
  sessionToken,
}: {
  userOid: string
  sessionToken: string
}) => {
  const { data } = await axios.get(getPackageListPathname(userOid), {
    headers: {
      session: sessionToken,
    },
  })
  return data.emoticonPackages
}

type PostPackageAPI = {
  formData: FormData
  sessionToken: string
}
type PutPackageAPIProp = PostPackageAPI & {
  packageId: string
}
export const putPackageAPI = async ({
  formData,
  sessionToken,
  packageId,
}: PutPackageAPIProp) => {
  const { data } = await axios.put(putPackagePathname(packageId), formData, {
    headers: {
      session: sessionToken,
    },
  })
  return data
}

export const submitPackageAPI = async ({
  packageId,
  sessionToken,
}: {
  packageId: string
  sessionToken: string
}) => {
  const { data } = await axios.put(
    submitPackagePathname(packageId),
    {},
    { headers: { session: sessionToken } },
  )
  return data
}

export const putPackageStatusEditingAPI = async ({
  packageId,
  sessionToken,
}: {
  packageId: string
  sessionToken: string
}) => {
  const { data } = await axios.put(
    putPackageStatusEditing(packageId),
    {},
    { headers: { session: sessionToken } },
  )
  return data
}

export const putPackageResetLang = async ({
  packageId,
  sessionToken,
}: {
  packageId: string
  sessionToken: string
}) => {
  const { data } = await axios.put(
    putPackageResetPathname(packageId),
    {},
    { headers: { session: sessionToken } },
  )
  return data
}
